import { z } from "zod";

import { RateGroupTypeList } from "../shipping-rate-groups";
import { ShippingRateDtoSchema } from "../shipping-rates";

export const ShippingRateGroupDtoSchema_2023_08_20 = z.object({
  groupType: z.enum(RateGroupTypeList),
  position: z.number(), // rendering order
  rates: ShippingRateDtoSchema.array(),
  id: z.string().uuid(),
});
export type ShippingRateGroupDto_2023_08_20 = z.infer<
  typeof ShippingRateGroupDtoSchema_2023_08_20
>;
